export class CountryWithStateModel {
  id: string;
  name: string;
  code: number;
  flagURL: string;
  states: StateModel[];
  abbreviationName: string;
  constructor(data?: Partial<CountryWithStateModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.flagURL = data?.flagURL || "";
    this.code = data?.code || 0;
    this.states = data?.states?.map((state) => new StateModel(state)) || [];
    this.abbreviationName = data?.abbreviationName || "";
  }
}
export class StateModel {
  id: string;
  name: string;
  constructor(data?: Partial<StateModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
  }
}
